class MultiquoteFullCoveragesPermissions {
    constructor({ show = false } = {}) {
        this.show = show
    }
}

export default MultiquoteFullCoveragesPermissions
